import * as models from "app/models/requireme";
import { obtenerInfoEntrega } from "../entrega/logic";
import * as kea from "kea-react";
import { mapMany, first, orderBy, orderByDesc } from "keautils";

import { obtenerTotalAPagar } from "../entrega/logic";
export interface EntregaItem {
    IdDireccionDestino: number;
    CantGuiasTotal: number;
    CantGuiasEntregadas: number;
    CantGuiasRechazadas: number;
    Fecha: Date;
    ClaveUnica: string;
    Finalizado: boolean;
    TotalPagar: number;
}

export interface InfoDireccion {
    Descripcion: string;
    DescripcionCorta: string;
    NombreCliente: string;
    TelefonoCliente: string;
}

/**Obtiene la información de la dirección actual */
export function obtenerInfoDireccion(state: models.ViajeAppIniciado, idDireccionDestino: number): InfoDireccion {
    const direcciones = mapMany(state.datos.Clientes, x => x.Direcciones);
    const direccion = first(direcciones, x => x.IdRegistro == idDireccionDestino)!;
    const cliente = first(state.datos.Clientes, x => x.IdRegistro == direccion.IdCliente)!;

    return {
        Descripcion: direccion.Direccion.Descripcion,
        DescripcionCorta: direccion.Direccion.Calle + " #" + direccion.Direccion.NoExterior + ", CP. " + direccion.Direccion.CodigoPostal,
        NombreCliente: cliente.Nombre,
        TelefonoCliente: cliente.Telefono
    };
}

/**Obtiene todas las entregas de una dirección de destino */
export function obtenerItems(state: models.ViajeAppIniciado, idDireccionDestino: number): EntregaItem[] {
    const items =
        orderByDesc(
            state.model.EntregasRealizadas
                .filter(x => x.IdDireccionDestino == idDireccionDestino)
                .map(x => ({
                    datos: x,
                    info: obtenerInfoEntrega(state, x.ClaveUnica)
                }))
                .map<EntregaItem>(x => ({
                    IdDireccionDestino: x.datos.IdDireccionDestino,
                    CantGuiasTotal: x.info.CantGuias,
                    CantGuiasEntregadas: x.info.GuiasEntregadas,
                    CantGuiasRechazadas: x.info.GuiasRechazadas,
                    Fecha: kea.toDate(x.datos.Fecha),
                    ClaveUnica: x.datos.ClaveUnica,
                    Finalizado: x.datos.Finalizado,
                    TotalPagar: obtenerTotalAPagar(state, x.datos.ClaveUnica).entregadas
                })), x => x.Fecha);

    return items;
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entregas/model.ts